import React from 'react';

export const RoundedTriangleArrow = (props: any) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.817396 3.362C0.0175666 2.02895 0.977792 0.333007 2.53238 0.333007L11.4676 0.333008C13.0222 0.333008 13.9824 2.02895 13.1826 3.362L8.71499 10.808C7.93818 12.1027 6.06182 12.1027 5.28501 10.808L0.817396 3.362Z"
      fill="#919393"
    />
  </svg>
);
